module.exports = __webpack_public_path__ + "static/media/trimex_saratoga.3d27b1db.png";